import { createFileRoute, redirect, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_admin")({
  beforeLoad: async ({ context }) => {
    const session = context.session;
    if (!session || session.user.role !== "admin") {
      throw redirect({ to: "/dashboard" });
    }
    return {};
  },
  component: AdminLayout,
});

function AdminLayout() {
  return <Outlet />;
}
